import { getInitialState } from './state';

const mutations = {
  SET_CLEAR_HEALTHINSURANCE(state) {
    Object.assign(state, getInitialState());
  },

  SET_CLEAR_HEALTH_INSURANCE_LISTS(state) {
    state.data.healthInsuranceVariables = [];
    state.data.healthInsuranceList = [];
  },

  SET_CLEAR_HEALTH_INSURANCE_CARD_INFOS(state) {
    state.data = {
      ...state.data,
      healthInsuranceCardInfos: {
        cardNumber: ''
      }
    };
  },

  SET_HEALTH_INSURANCE_LIST(state, healthInsuranceList) {
    state.data.healthInsuranceList = healthInsuranceList;
  },

  SET_HEALTH_INSURANCE_VARIABLES(state, healthInsuranceVariables) {
    state.data.healthInsuranceVariables = healthInsuranceVariables;
  },

  SET_HEALTH_INSURANCE_UPDATE_STATUS(state, status) {
    state.data.updateStatus = status;
  },

  SET_HEALTH_INSURANCE_RECENT_CARDS(state, recentCards) {
    state.data.healthInsuranceRecentCards = recentCards;
  },

  SET_HEALTH_INSURANCE_CARD_NUMBER(state, cardNumber) {
    state.data.healthInsuranceCardInfos.cardNumber = cardNumber;
  },
};

export default mutations;
